module.exports = __webpack_public_path__ + "img/powerball_ad1.3740cd75.png";